<template>
  <div id="project" class="project__edit__wrapper">
    <HeaderControlsProject :myWeek='false' @filterUpdated='false' @collapseToggleUpdated='false'  :namespace="namespace"/>
    <div class="container-fluid project--details">
      <ProjectDeliverableList  :namespace="namespace"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HeaderControlsProject from "../components/common/HeaderControlsProject";
import ProjectDeliverableList from "../components/deliverables/ProjectDeliverableList";

export default {
  data() {
    return {
    	namespace:""
    }
  },
  components: {
    ...mapGetters([
      'projectDeliverables'
    ]),
    HeaderControlsProject,
    ProjectDeliverableList
  },
};
</script>
